module.exports = __webpack_public_path__ + "media/images/icons/twotone/file-word-bd8489995a29863a0cde3c77077e27c1.svg";